import React from 'react'
import { InferGetServerSidePropsType } from 'next'

import { getServerSideProps } from 'src/pages/builder/server'
import SimplePage from 'src/pages/builder/simplePage'

const pagePathView = '/privacy'
const pageId = 'privacy'

export { pagePathView, pageId }

type Props = InferGetServerSidePropsType<typeof getServerSideProps>

export default (props: Props) => {
  return <SimplePage {...props} pageId={pageId} />
}

export { getServerSideProps }
